module.exports = __webpack_public_path__ + "static/img/The Hermit.59ed006.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The Hermit.jpg
// module id = 1314
// module chunks = 0